<template lang="pug">
  media(v-bind="$attrs", :count="[active, items.length]", :aspectRatio="aspectRatio", :ratio="originalRatio")
    //- media: click to enlarge (desktop), drag or swipe through the folio (E2) — each image sits in
    //- its own place around a looping track (trackStyle) and slides in following the drag,
    //- Instagram-style, so the last image leads straight back into the first
    .absolute.inset-0.w-full.h-full.imageset.overflow-hidden(slot="media", ref="frame", @click="onFrameClick", :class="{'lg-cursor-expand': !dragging}", :style="{touchAction: items.length > 1 ? 'pan-y' : 'auto'}")
      resp-img(v-for="(item, i) in items", v-if="imgL && img(item)", :key="img(item).url || i", :bg="true", :lazy="(defer || i > 0) && !warm[i]", :lngth="imgL", :useHeight="isPortrait", :src="img(item).url", :alt="img(item).alt || $prismic.richTextAsPlain(item.caption)", :style="trackStyle(i, active, items.length)")
      nav.absolute.z-10.inset-0.flex.justify-between(v-if="items.length > 1")
        button.hidden.lg-block.lg-w-1x3.cursor-left-arrow(@click.stop="onNavClick(-1)", aria-label="Previous Image")
        button.w-full.lg-w-1x3.cursor-right-arrow(@click.stop="onNavClick(1)", aria-label="Next Image")
    //- caption
    span(slot="caption", v-if="activeItm")
      prismic-rich-text.inline.children-inline(v-if="activeItm.caption", :field="activeItm.caption")
</template>

<script>
import Media from './Media'
import RespImg from '@/components/RespImg'
import { mapGetters } from 'vuex'
import DragTrack from '@/mixins/DragTrack'
import { canObserve } from '@/utils'
export default {
  name: 'Imageset',
  mixins: [DragTrack],
  props: ['items', 'aspectRatio', 'view', 'defer', 'original'],
  data () {
    return {
      active: 0,
      imgL: 0,
      // slides loaded eagerly: the current one and its neighbours, once the carousel is near the
      // screen. The lazy loader only fetches what is actually on screen, and a neighbour waits
      // clipped just off the frame, so it would otherwise arrive blank and fade in (a flash)
      warm: {},
      frameObserver: null
    }
  },
  computed: {
    ...mapGetters(['winIs']),
    activeItm () {
      return this.items && this.items[this.active]
    },
    isPortrait () {
      return !this.original && this.aspectRatio === '4x5'
    },
    // shown uncropped: the frame takes the shape of the photograph on screen
    originalRatio () {
      if (!this.original) return 0
      const d = this.activeItm && this.activeItm.image && this.activeItm.image.dimensions
      return d && d.width && d.height ? +(d.width / d.height).toFixed(4) : 0
    }
  },
  methods: {
    next (incr = 1) {
      const actv = this.active
      const total = this.items.length
      this.active = actv + incr === total ? 0 : actv + incr < 0 ? total - 1 : actv + incr
    },
    setImgL () {
      if (!this.$refs.frame) return
      this.imgL = this.isPortrait ? this.$refs.frame.offsetHeight : this.$refs.frame.offsetWidth
    },
    openViewer (url) {
      if (this.winIs('lg')) return this.$store.commit('OPEN_VIEWER', url)
    },
    onFrameClick () {
      if (this.swiped || !this.activeItm || !this.img(this.activeItm)) return
      // the viewer indexes media by the main image URL, not by the cropped view
      this.openViewer(this.activeItm.image.url)
    },
    onNavClick (incr) {
      if (this.swiped) return
      this.next(incr)
    },
    img (item) {
      const img = item && item.image
      if (!img || !img.url) return false
      // uncropped: always the main image, never one of the ratio views
      if (this.original) return img
      const ar = (this.aspectRatio || '').replace('x', ':')
      // a named view (e.g. full-bleed) when the model has it, else the ratio view, else the main image
      const view = this.view && img[this.view] && img[this.view].url ? img[this.view] : null
      return view || (img[ar] && img[ar].url ? img[ar] : img)
    },
    warmAround (i) {
      const n = this.items.length
      ;[i - 1, i, i + 1].forEach(k => this.$set(this.warm, ((k % n) + n) % n, true))
    }
  },
  watch: {
    active (i) {
      if (this.items.length > 1) this.warmAround(i)
    }
  },
  mounted () {
    setTimeout(() => this.setImgL(), 800) // after page anim
    if (this.items.length > 1) {
      this.bindDragTrack(this.$refs.frame, { onSwipeLeft: () => this.next(1), onSwipeRight: () => this.next(-1) })
      // warm the neighbours once the carousel comes near the screen, so carousels further down the
      // page still wait (the project page's light first load is kept)
      if (!canObserve()) return this.warmAround(this.active)
      this.frameObserver = new IntersectionObserver(entries => {
        if (!entries.some(e => e.isIntersecting)) return
        this.warmAround(this.active)
        this.frameObserver.disconnect()
        this.frameObserver = null
      }, { rootMargin: '300px 0px' })
      this.frameObserver.observe(this.$refs.frame)
    }
  },
  beforeDestroy () {
    if (this.frameObserver) this.frameObserver.disconnect()
  },
  components: { Media, RespImg },
  inheritAttrs: false
}
</script>

<style>
.imageset { -webkit-user-select: none; user-select: none; }
</style>
